import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import "./ViewOrder.css"

const ViewOrder = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_SERVER}/api/orders/${id}`)
      .then((res) => {
        setOrder(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching order", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p>Loading order details...</p>;
  if (!order) return <p>Order not found.</p>;

  return (
    <div className="order-details-container">
      <h2>Order Details (ID: {order._id})</h2>

      <div className="order-info">
        <p>
          <span>User:</span> {order.user}
        </p>
        <p>
          <span>Total Price:</span> ${order.totalAmount}
        </p>
        <p>
          <span>Payment Method:</span> {order.paymentMethod}
        </p>
        <p>
          <span>Payment Status:</span> {order.paymentStatus}
        </p>
        <p>
          <span>Order Status:</span> {order.orderStatus}
        </p>
        <p>
          <span>Shipping Address:</span> {order.shippingAddress.address}
        </p>
        <p>
          <span>Contect:</span> {order.shippingAddress.phone}
        </p>
        <p>
          <span>Created At:</span> {new Date(order.createdAt).toLocaleString()}
        </p>
      </div>

      <div className="order-info">
        <p>
          <span>Items:</span>
        </p>
      </div>
      <ul className="order-items">
        {order.products.map((item, index) => (
          <li key={index}>
            <span>{item.product}</span> x <span>{item.quantity}</span> = $
            <strong>{item.productPrice * item.quantity}</strong>
          </li>
        ))}
      </ul>
      <Link to="/admin/orders">
        <button className="back-btn">Back to User Orders</button>
      </Link>
    </div>
  );
};

export default ViewOrder;
